export enum AssessmentDisplayStatus {
  COMPLETE = 'Completed',
  IN_PROGRESS = 'In progress',
  INCOMPLETE = 'Incomplete',
  NEW = 'New',
}
